export const WEIGHT_SCALE = [1, 2, 3, 4, 5] as const;
